/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : UnlinkLegalDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import CustomDialogBoxV2 from "../../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomFormTextFieldV2 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";
import { Box } from "@mui/material";

function UnlinkLegalDialog({
  openDialog,
  onClose,
  onSuccess,
  reason,
  setReason,
}) {
  const [enableReasonSubmit, setEnableReasonSubmit] = useState(false);
  return (
    <CustomDialogBoxV2
      open={openDialog}
      onClose={onClose}
      title="Reason For Unlinking Legal Requirement"
      successButtonName={"Confirm"}
      rejectButtonName={"Cancel"}
      onClickSuccess={() => {
        onSuccess(reason);
      }}
      onClickReject={onClose}
      onDisabled={!enableReasonSubmit}
      actionButtonStyle={"continuous"}
    >
      <Box sx={{ width: "350px" }}>
        <CustomFormTextFieldV2
          label="Reason"
          required={true}
          value={reason}
          setValue={(value) => {
            setReason(value);
            if (value.length > 2) {
              setEnableReasonSubmit(true);
            } else {
              setEnableReasonSubmit(false);
            }
          }}
        />
      </Box>
    </CustomDialogBoxV2>
  );
}

export default UnlinkLegalDialog;
